import { resourcesCategoryListComponent } from './resource-category-list.component';
import './resource-category-list.scss';

export const resourcesCategoryList = angular
.module('components.resources.resourceCategoryList', [])
.component('resourcesCategoryList', resourcesCategoryListComponent)
.config(($stateProvider) => {
    'ngInject';
    
            $stateProvider
                .state('resourceCategory', {
                    parent: 'app',
                    url: '/home/resources/:slug',
                    breadcrumbName: 'category',
                    parentState: 'resources',
                    component: 'resourcesCategoryList',
                    resolve: {
                        details($stateParams, resourcesService){
                            'ngInject';
                            return resourcesService.getResourcesCategoryDetailsById($stateParams.slug);
                        }
                        
                    }
                    
                });
})
.name;



// WEBPACK FOOTER //
// ./src/app/components/resources/resource-category/resource-category-list.module.js